import { IExternalComponent } from './IExternalComponent';
import { IPostExternalComponentClosed } from './IPostExternalComponentClosed';
import { IPostExternalComponentOpened } from './IPostExternalComponentOpened';

export { IExternalComponent, IPostExternalComponentClosed, IPostExternalComponentOpened };
